import { invoiceDetailInitial } from '../../store/InitialStore';
import * as types from '../../actions/ActionTypes';

export default function InvoiceDetailReducer(state = invoiceDetailInitial, action) {
  const { type, payload } = action;

  switch (type) {
    case types.INVOICE_DETAIL_LOADING:
      return {loading : true  , detail : {}, error : false };
    case types.INVOICE_DETAIL_SUCCESS:
      return {loading : false , detail : payload, error : false}; 
    case types.INVOICE_DETAIL_ERROR:
      return {loading : false , detail : payload , error : true};    
    default:
      return state;
  }
}
